<template>
  <div class="feeTypeListRratePage">
    <div class="mb10">
      <Button type="primary" @click="addTbalRow" v-if="isEdit">添加工艺要求说明</Button>
    </div>
    <Form ref="pageFromRef" :model="formData" :rules="ruleValidate" :label-width="100" class="fmb0 flex1">
      <Table border :columns="sewingColumns" :data="formData.tableData">
        <template slot-scope="{ row, index }" slot="processRequireName">
          <FormItem
            v-if="isEdit"
            label=""
            :prop="`tableData.${index}.processRequireName`"
            class="item-input"
            :label-width="0"
            :rules="tableRule.processRequireName"
          >
            <Input  v-model="formData.tableData[index].processRequireName" placeholder="请输入工艺名称" />
          </FormItem>
          <span v-else>{{ row.processRequireName }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="processRequireDesc">
          <FormItem
            v-if="isEdit"
            label=""
            :prop="`tableData.${index}.processRequireDesc`"
            class="item-input"
            :label-width="0"
            :rules="tableRule.processRequireDesc"
          >
            <Input
                type="textarea"
               v-model="formData.tableData[index].processRequireDesc"
               :autosize="{ minRows: 3, maxRows: 6 }"
               placeholder="请输入工艺要求"
            />
          </FormItem>
          <span v-else>{{ row.processRequireDesc }}</span>
        </template>
      </Table>
    </Form>
    <Spin v-if="pageLoading" fix></Spin>
  </div>
</template>
<script>
// import api from '@/api/api.js';

export default {
  name: "feeTypeListRrate",
  components: { },
  props: {
    // 是否显示
    modelVisible: { type: Boolean, default: false },
    // 是否禁用
    disabled: { type: Boolean, default: false },
    // 商品数据
    productData: { type: Object, default () { return {} } }
  },
  data() {
    return {
      pageLoading: false,
      formData: {
        tableData: [],
      },
      ruleValidate: {},
      tableRule: {
        processRequireName: [
          { required: true, validator: this.requireNameVerify, maxLength: 30, msg: '请输入工艺名称', trigger: 'change' },
          { required: true, validator: this.requireNameVerify, maxLength: 30, msg: '请输入工艺名称', trigger: 'blur' },
        ],
        processRequireDesc: [
          { required: true, validator: this.$common.strMaxVerify, maxLength: 1000, msg: '请输入工艺要求', trigger: 'change' },
          { required: true, validator: this.$common.strMaxVerify, maxLength: 1000, msg: '请输入工艺要求', trigger: 'blur' },
        ]
      },
      sewingTableCol: [
        {
          title: '工艺名称',
          slot: 'processRequireName',
          align: 'center',
        },
        {
          title: '要求',
          slot: 'processRequireDesc',
          align: 'center',
        }
      ],
      formValidate: {},
    };
  },
  watch: {
    modelVisible: {
      immediate: true,
      deep: true,
      handler (val) {
        if (!val) return this.resetData();
        this.$nextTick(() => {
          this.pageInit(this.processRequireList || []);
          setTimeout(() => {
            this.pageInit(this.processRequireList);
          }, 300)
        })
      }
    }
  },
  computed: {
    // 费用数据
    processRequireList () {
      if (this.$common.isEmpty(this.productData) || this.$common.isEmpty(this.productData.productProcessRequireList)) return [];
      return this.$common.copy(this.productData.productProcessRequireList);
    },
    // 是否可编辑
    isEdit () {
      return !this.disabled;
    },
    // 列表列设置
    sewingColumns () {
      const operation = {
        title: '操作',
        key: 'index',
        width: '120',
        align: 'center',
        render: (h, { row, index }) => {
          return h('div', {
            style: {
              display: 'inline-block',
              cursor: 'pointer',
              color: '#2d8cf0',
            },
            on: {
              'click': () => {
                this.removeTableRow(row, index);
              }
            }
          }, '移除')
        },
      }
      return this.isEdit ? [operation, ...this.sewingTableCol] : this.sewingTableCol;
    },
  },
  created() {},
  methods: {
    pageInit (datas) {
      this.pageLoading = true;
      let awaitRes = [
        () => {
          return this.detail(datas);
        }
      ];
      this.$common.promiseAll(awaitRes).then(resArr => {
        this.pageLoading = false;
      }).catch(() => {
        this.pageLoading = false;
      })
    },
    // 重置数据
    resetData () {
      this.formData.tableData = [];
      this.formValidate = {}
    },
    detail(temps) {
      return new Promise((resolve) => {
        if (this.$common.isEmpty(temps)) return resolve(temps);
        this.formData.tableData = temps;
        resolve(temps);
      })
    },
    // 返回表单值 type 为 1 时验证， 其他值不验证
    getFormData (type) {
      return new Promise((resolve) => {
        const notEmpty = this.formData.tableData.find(row => {
          return !this.$common.isEmpty((row.processRequireName || '').trim()) || !this.$common.isEmpty((row.processRequireDesc || '').trim());
        });
        // 当列表为空或列表时间都为空，不验证
        if (type != 1 || this.$common.isEmpty(notEmpty)) {
          resolve({
            success: true,
            data: this.$common.isEmpty(notEmpty) ? [] : this.formData.tableData
          });
          return;
        }
        this.$refs.pageFromRef.validate((valid) => {
          if (!valid) {
            this.$Message.error('“工艺要求说明”表单验证不通过，请检查');
            return resolve({ success: false, message: '“工艺要求说明”表单验证不通过，请检查' });
          }
          resolve({
            success: true,
            data: this.formData.tableData
          });
        })
      })
    },
    // 移除行
    removeTableRow (row, index) {
      if (this.$common.isEmpty(row.processRequireName)) {
        this.formData.tableData.splice(index, 1);
        return;
      }
      this.$Modal.confirm({
        title: '操作',
        content: `<div>确认移除工艺：<span style="color:#f20;">${row.processRequireName}</span>？</div>`,
        loading: true,
        onOk: () => {
          this.$Modal.remove();
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.formData.tableData.splice(index, 1);
        }
      });
    },
    // 新增列表行
    addTbalRow () {
      this.formData.tableData.push({
        processRequireDesc: '',
        processRequireName: '',
      })
    },
    // 验证工艺名称
    requireNameVerify (rule, value, callback) {
      this.$nextTick(() => {
        const newValue = (value || '').trim();
        if (this.$common.isEmpty(newValue)) {
          return callback(new Error(rule.msg || '必填项不能为空'));
        }
        let reatName = [];
        this.formData.tableData.forEach((row) => {
          if (newValue == row.processRequireName) {
            reatName.push(row.processRequireName);
          }
        });
        if (reatName.length > 1) {
          return callback(new Error('工艺名称不能重复！'));
        }
        this.$common.strMaxVerify(rule, newValue, callback);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.feeTypeListRratePage {
  position: relative;
  padding: 10px;
  .table-footer {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border: 1px solid #dcdee2;
    border-top: none;
    background-color: #f8f8f9;

    .seat {
      width: 120px;
    }

    .flex1 {
      flex: 1;
      display: flex;
      justify-content: center;
    }
  }
  :deep(.item-input) {
    &.ivu-form-item {
      margin: 0;
    }
  }
}
</style>
